import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Download, Lock, Award } from 'lucide-react';
const CHECKOUT_URL = 'https://noveliahub.com/cart/50875095482404:1';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handleCheckout = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
  };
  return <section ref={ref} className="w-full bg-gradient-to-b from-white to-orange-100 py-16 md:py-24" data-id="element-53">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-55">
          <h2 className="font-fredoka text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-56">
            No esperes más...
          </h2>

          <p className="font-nunito text-xl sm:text-2xl text-gray-700 mb-4 leading-relaxed" data-id="element-57">
            Cada día frente a la pantalla es un día menos de desarrollo
            creativo.
          </p>

          <p className="font-fredoka text-2xl sm:text-3xl font-bold text-orange-600 mb-8" data-id="element-58">
            Hoy puedes cambiarlo por solo $6.36
          </p>

          <motion.a href={CHECKOUT_URL} onClick={handleCheckout} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-orange-500 hover:bg-orange-600 text-white font-fredoka font-bold text-xl sm:text-2xl px-12 py-6 rounded-full shadow-lg hover:shadow-xl transition-all mb-8 inline-block" data-id="element-59">
            COMPRAR AHORA / BUY NOW — $6.36
          </motion.a>

          <div className="flex flex-wrap justify-center gap-6 text-sm sm:text-base" data-id="element-60">
            <div className="flex items-center gap-2 text-gray-700" data-id="element-61">
              <Download className="w-5 h-5 text-orange-600" data-id="element-62" />
              <span className="font-nunito font-semibold" data-id="element-63">
                Descarga instantánea
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-700" data-id="element-64">
              <Lock className="w-5 h-5 text-orange-600" data-id="element-65" />
              <span className="font-nunito font-semibold" data-id="element-66">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700" data-id="element-67">
              <Award className="w-5 h-5 text-orange-600" data-id="element-68" />
              <span className="font-nunito font-semibold" data-id="element-69">
                Garantía 30 días
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}